import first from 'lodash/fp/first';
import flow from 'lodash/fp/flow';
import get from 'lodash/fp/get';

/**
 * Extracts the first error field name from form validation errorInfo.
 */
export function getFirstErrorFieldName(errorInfo) {
  return flow([get('errorFields'), first, get('name'), first])(errorInfo);
}
